import { getParamFromSortState, getQueryParams } from '../../../helpers/Common';
import reducerRegistry from '../../../helpers/ReducerRegistry';
import taStrategyService from '../../../../core/services/Strategy/TAStrategyService';
import Interval from '../../../../../src/component/helpers/IntervalCallApi';
import Const from './Const';
import { keyBy } from 'lodash';
import ConstCommon from './../../../common/Const';
import currentState from './../../../helpers/CurrentState';

const PAGE_SIZE = 50;
const DEFAULT_PAGE_LOAD = 1;

const REDUCER_NAME = 'TA_FIINTRADE_STRATEGY:';
const FETCH_LIST_ACCUMULATION_DATA = `${REDUCER_NAME}FETCH_LIST_ACCUMULATION_DATA`;
const FETCH_LIST_BREAKOUT_DATA = `${REDUCER_NAME}FETCH_LIST_BREAKOUT_DATA`;
const FETCH_LIST_BREAKOUT_MA_DATA = `${REDUCER_NAME}FETCH_LIST_BREAKOUT_MA_DATA`;
const FETCH_LIST_BEST_DOWN_TREND_DATA = `${REDUCER_NAME}FETCH_LIST_BEST_DOWN_TREND_DATA`;
const FETCH_LIST_MARKET_ABNOMALY_DATA = `${REDUCER_NAME}FETCH_LIST_MARKET_ABNOMALY_DATA`;

const SUBSCRIBE_REALTIME_TICK_ACCUMULATION = `${REDUCER_NAME}SUBSCRIBE_REALTIME_TICK_ACCUMULATION`;
const SUBSCRIBE_REALTIME_TICK_BREAKOUT = `${REDUCER_NAME}SUBSCRIBE_REALTIME_TICK_BREAKOUT`;
const SUBSCRIBE_REALTIME_TICK_BREAKOUT_MA = `${REDUCER_NAME}SUBSCRIBE_REALTIME_TICK_BREAKOUT_MA`;
const SUBSCRIBE_REALTIME_TICK_BEST_DOWN = `${REDUCER_NAME}SUBSCRIBE_REALTIME_TICK_BEST_DOWN`;
const SUBSCRIBE_REALTIME_TICK_MARKET_ABNOMALY = `${REDUCER_NAME}SUBSCRIBE_REALTIME_TICK_MARKET_ABNOMALY`;

const GET_FILTER_LINE_ONE = `${REDUCER_NAME}GET_FILTER_LINE_ONE`;
const GET_FILTER_LINE_TWO = `${REDUCER_NAME}GET_FILTER_LINE_TWO`;
const GET_FILTER_LINE_THREE = `${REDUCER_NAME}GET_FILTER_LINE_THREE`;
const GET_FILTER_LINE_FOUR = `${REDUCER_NAME}GET_FILTER_LINE_FOUR`;
const CHANGE_BREAKOUT_TYPE = `${REDUCER_NAME}CHANGE_BREAKOUT_TYPE`;
const CHANGE_BREAKOUT_MA_TYPE = `${REDUCER_NAME}CHANGE_BREAKOUT_MA_TYPE`;
const CHANGE_MARKET_NORMALLY_CHECK = `${REDUCER_NAME}CHANGE_MARKET_NORMALLY_CHECK`;

const CHANGE_TAB_DATA = `${REDUCER_NAME}CHANGE_TAB_DATA`;

const LOAD_MORE_DATA = `${REDUCER_NAME}LOAD_MORE_DATA`;
const LOAD_MORE_BREAKOUT_DATA = `${REDUCER_NAME}LOAD_MORE_BREAKOUT_DATA`;
const LOAD_MORE_BREAKOUT_MA_DATA = `${REDUCER_NAME}LOAD_MORE_BREAKOUT_MA_DATA`;
const LOAD_MORE_BEST_DOWN_DATA = `${REDUCER_NAME}LOAD_MORE_BEST_DOWN_DATA`;
const LOAD_MORE_MARKET_ANOMALY = `${REDUCER_NAME}LOAD_MORE_MARKET_ANOMALY`;

const SET_LOADING = `${REDUCER_NAME}SET_LOADING`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const CHANGE_SORT_STATE = `${REDUCER_NAME}CHANGE_SORT_STATE`;

export {
  reducer as default,
  REDUCER_NAME,
  fetchAccumulation,
  fetchBreakout,
  fetchBreakoutMa,
  fetchBestInDownTrend,
  fetchMarketAnomaly,
  subscribeRealtimeTickAccumulation,
  subscribeRealtimeTickBestDown,
  subscribeRealtimeTickBreakout,
  subscribeRealtimeTickBreakoutMa,
  subscribeRealtimeTickMarketAnomaly,
  getFilterLineOne,
  getFilterLineTwo,
  getFilterLineThree,
  getFilterLineFour,
  changeTabData,
  changeBreakoutType,
  changeBreakoutMaType,
  changeMarketNormallyCheck,
  cancelFetchAccumulation,
  cancelFetchBreakout,
  cancelFetchBreakoutMa,
  cancelFetchBestInDownTrend,
  cancelFetchMarketAnomaly,
  loadMoreData,
  changeSortState,
  mapSortState,
};

function changeTabData(tab) {
  return dispatch => {
    currentState.add(
      ConstCommon.listComponent.Strategy,
      'TaStrategy.currentTabData',
      tab,
    );
    dispatch({
      type: CHANGE_TAB_DATA,
      payload: {
        tab,
      },
    });
  };
}

function changeSortState(sortState) {
  return {
    type: CHANGE_SORT_STATE,
    payload: sortState,
  };
}

function reLoadData(currentTabData) {
  return dispatch => {
    if (currentTabData === Const.tabs.accummulation) {
      dispatch(fetchAccumulation());
    }
    if (currentTabData === Const.tabs.breakOut) {
      dispatch(fetchBreakout());
    }
    if (currentTabData === Const.tabs.breakOutMa) {
      dispatch(fetchBreakoutMa());
    }
    if (currentTabData === Const.tabs.bestInDowntrend) {
      dispatch(fetchBestInDownTrend());
    }
    if (currentTabData === Const.tabs.marketAnomaly) {
      dispatch(fetchMarketAnomaly());
    }
  };
}

function loadMoreData(page, currentTabData) {
  return (dispatch, getState) => {
    const sortState = getState()[REDUCER_NAME].sortState;
    if (currentTabData === Const.tabs.accummulation) {
      const filterLineOne = getState()[REDUCER_NAME].filterData[currentTabData]
        .filterLineOne;
      const filterLineTwo = getState()[REDUCER_NAME].filterData[currentTabData]
        .filterLineTwo;
      const filterLineThree = getState()[REDUCER_NAME].filterData[
        currentTabData
      ].filterLineThree;
      dispatch(setLoading(true));
      taStrategyService
        .fetchAccumulation({
          Period: filterLineOne,
          VolumeRateOfChange: filterLineTwo,
          IncreaseInPrice: filterLineThree,
          Page: page,
          PageSize: PAGE_SIZE,
          ...getParamFromSortState(sortState),
        })
        .then(({ items }) => {
          if (items) {
            const listDataMore = items || [];
            dispatch({
              type: LOAD_MORE_DATA,
              payload: {
                listDataMore,
                page,
              },
            });
          }
          dispatch(setLoading(false));
        });
    }
    if (currentTabData === Const.tabs.breakOut) {
      const breakOutType = getState()[REDUCER_NAME].filterData[currentTabData]
        .breakOutType;
      const filterLineOne = getState()[REDUCER_NAME].filterData[currentTabData]
        .filterLineOne;
      const filterLineTwo = getState()[REDUCER_NAME].filterData[currentTabData]
        .filterLineTwo;
      const filterLineThree = getState()[REDUCER_NAME].filterData[
        currentTabData
      ].filterLineThree;
      dispatch(setLoading(true));
      taStrategyService
        .fetchBreakout({
          BreakoutType: breakOutType,
          TimeRange: filterLineOne,
          VolumeRateOfChange: filterLineTwo,
          ComGroupCode: filterLineThree,
          Page: page,
          PageSize: PAGE_SIZE,
          ...getParamFromSortState(sortState),
        })
        .then(({ items }) => {
          if (items) {
            const listDataMore = items || [];
            dispatch({
              type: LOAD_MORE_BREAKOUT_DATA,
              payload: {
                listDataMore,
                page,
              },
            });
          }
          dispatch(setLoading(false));
        });
    }
    if (currentTabData === Const.tabs.breakOutMa) {
      const breakOutType = getState()[REDUCER_NAME].filterData[currentTabData]
        .breakOutType;
      const filterLineOne = getState()[REDUCER_NAME].filterData[currentTabData]
        .filterLineOne;
      const filterLineTwo = getState()[REDUCER_NAME].filterData[currentTabData]
        .filterLineTwo;
      const filterLineThree = getState()[REDUCER_NAME].filterData[
        currentTabData
      ].filterLineThree;
      dispatch(setLoading(true));
      taStrategyService
        .fetchBreakoutMa({
          BreakoutType: breakOutType,
          TimeRange: filterLineOne,
          VolumeRateOfChange: filterLineTwo,
          ComGroupCode: filterLineThree,
          Page: page,
          PageSize: PAGE_SIZE,
          ...getParamFromSortState(sortState),
        })
        .then(({ items }) => {
          if (items) {
            const listDataMore = items || [];
            dispatch({
              type: LOAD_MORE_BREAKOUT_MA_DATA,
              payload: {
                listDataMore,
                page,
              },
            });
          }
          dispatch(setLoading(false));
        });
    }

    if (currentTabData === Const.tabs.bestInDowntrend) {
      const filterLineOne = getState()[REDUCER_NAME].filterData[currentTabData]
        .filterLineOne;
      const filterLineTwo = getState()[REDUCER_NAME].filterData[currentTabData]
        .filterLineTwo;
      const filterLineThree = getState()[REDUCER_NAME].filterData[
        currentTabData
      ].filterLineThree;
      dispatch(setLoading(true));
      taStrategyService
        .fetchBestInDownTrend({
          DownTrend: filterLineOne,
          AverageMatchVolume1Month: filterLineTwo,
          ComGroupCode: filterLineThree,
          Page: page,
          PageSize: PAGE_SIZE,
          ...getParamFromSortState(sortState, { icbRank: 'IcbTotalRanked' }),
        })
        .then(({ items }) => {
          if (items) {
            const listDataMore = items || [];
            dispatch({
              type: LOAD_MORE_BEST_DOWN_DATA,
              payload: {
                listDataMore,
                page,
              },
            });
          }
          dispatch(setLoading(false));
        });
    }
  };
}

function changeBreakoutType(breakOutType) {
  return (dispatch, globalState) => {
    dispatch({
      type: CHANGE_BREAKOUT_TYPE,
      payload: {
        breakOutType,
      },
    });
    const currentTabData = globalState()[REDUCER_NAME].currentTabData;
    dispatch(reLoadData(currentTabData));
  };
}

function changeBreakoutMaType(breakOutMAType) {
  return (dispatch, globalState) => {
    dispatch({
      type: CHANGE_BREAKOUT_MA_TYPE,
      payload: {
        breakOutMAType,
      },
    });
    const currentTabData = globalState()[REDUCER_NAME].currentTabData;
    dispatch(reLoadData(currentTabData));
  };
}

function changeMarketNormallyCheck(checkboxMarketNormally) {
  let lineOne = '';
  if (
    checkboxMarketNormally === Const.filterMarketAbnormally.optionTime.Daily
  ) {
    lineOne = Const.filterMarketAbnormally.filterWeekday[1];
  }
  if (
    checkboxMarketNormally === Const.filterMarketAbnormally.optionTime.Monthly
  ) {
    lineOne = Const.filterMarketAbnormally.filterMonthly[1];
  }
  if (
    checkboxMarketNormally === Const.filterMarketAbnormally.optionTime.Quarterly
  ) {
    lineOne = Const.filterMarketAbnormally.filterQuarterly[1];
  }
  return dispatch => {
    dispatch({
      type: CHANGE_MARKET_NORMALLY_CHECK,
      payload: {
        checkboxMarketNormally,
        lineOne,
      },
    });
    dispatch(fetchMarketAnomaly());
  };
}

function getFilterLineOne(value) {
  return (dispatch, globalState) => {
    dispatch({
      type: GET_FILTER_LINE_ONE,
      payload: {
        value,
      },
    });
    const currentTabData = globalState()[REDUCER_NAME].currentTabData;
    dispatch(reLoadData(currentTabData));
  };
}

function getFilterLineTwo(value) {
  return (dispatch, globalState) => {
    dispatch({
      type: GET_FILTER_LINE_TWO,
      payload: {
        value,
      },
    });
    const currentTabData = globalState()[REDUCER_NAME].currentTabData;
    dispatch(reLoadData(currentTabData));
  };
}

function getFilterLineThree(value) {
  return (dispatch, globalState) => {
    dispatch({
      type: GET_FILTER_LINE_THREE,
      payload: {
        value,
      },
    });
    const currentTabData = globalState()[REDUCER_NAME].currentTabData;
    dispatch(reLoadData(currentTabData));
  };
}

function getFilterLineFour(value) {
  return (dispatch, globalState) => {
    dispatch({
      type: GET_FILTER_LINE_FOUR,
      payload: {
        value,
      },
    });
    const currentTabData = globalState()[REDUCER_NAME].currentTabData;
    dispatch(reLoadData(currentTabData));
  };
}

function cancelFetchAccumulation() {
  return () => {
    Interval.cancel('TAStrategyAccumulation');
  };
}

function fetchAccumulation() {
  return (dispatch, getState) => {
    const currentpage = DEFAULT_PAGE_LOAD;
    const sortState = getState()[REDUCER_NAME].sortState;
    const currentTabData = getState()[REDUCER_NAME].currentTabData;
    const filterLineOne = getState()[REDUCER_NAME].filterData[currentTabData]
      .filterLineOne;
    const filterLineTwo = getState()[REDUCER_NAME].filterData[currentTabData]
      .filterLineTwo;
    const filterLineThree = getState()[REDUCER_NAME].filterData[currentTabData]
      .filterLineThree;
    Interval.fetch(
      'TAStrategyAccumulation',
      dispatch,
      function() {
        dispatch(setLoading(true));
        return taStrategyService.fetchAccumulation({
          Period: filterLineOne,
          VolumeRateOfChange: filterLineTwo,
          IncreaseInPrice: filterLineThree,
          Page: currentpage,
          PageSize: PAGE_SIZE,
          ...getParamFromSortState(sortState),
        });
      },
      function(response) {
        if (response) {
          const listAccumulationData = response.items || [];
          const totalPage = Math.ceil(response.totalCount / PAGE_SIZE);
          dispatch({
            type: FETCH_LIST_ACCUMULATION_DATA,
            payload: {
              listAccumulationData,
              totalPage,
              page: currentpage,
            },
          });
          dispatch(setLoading(false));
        }
      },
      Const.accumulationInterval,
    );
  };
}

function cancelFetchBreakout() {
  return () => {
    Interval.cancel('TAStrategyBreakout');
  };
}

function fetchBreakout() {
  return (dispatch, getState) => {
    const currentpage = DEFAULT_PAGE_LOAD;
    const currentTabData = getState()[REDUCER_NAME].currentTabData;
    const breakOutType = getState()[REDUCER_NAME].filterData[currentTabData]
      .breakOutType;
    const filterLineOne = getState()[REDUCER_NAME].filterData[currentTabData]
      .filterLineOne;
    const filterLineTwo = getState()[REDUCER_NAME].filterData[currentTabData]
      .filterLineTwo;
    const filterLineThree = getState()[REDUCER_NAME].filterData[currentTabData]
      .filterLineThree;
    const sortState = getState()[REDUCER_NAME].sortState;
    Interval.fetch(
      'TAStrategyBreakout',
      dispatch,
      function() {
        dispatch(setLoading(true));
        return taStrategyService.fetchBreakout({
          BreakoutType: breakOutType,
          TimeRange: filterLineOne,
          VolumeRateOfChange: filterLineTwo,
          ComGroupCode: filterLineThree,
          Page: currentpage,
          PageSize: PAGE_SIZE,
          ...getParamFromSortState(sortState),
        });
      },
      function(response) {
        if (response) {
          const listBreakoutData = response.items || [];
          const totalPage = Math.ceil(response.totalCount / PAGE_SIZE);
          dispatch({
            type: FETCH_LIST_BREAKOUT_DATA,
            payload: {
              listBreakoutData,
              totalPage,
            },
          });
          dispatch(setLoading(false));
        }
      },
      Const.breakoutInterval,
    );
  };
}

function cancelFetchBreakoutMa() {
  return () => {
    Interval.cancel('TAStrategyBreakoutMa');
  };
}

function fetchBreakoutMa() {
  return (dispatch, getState) => {
    const currentpage = DEFAULT_PAGE_LOAD;
    const currentTabData = getState()[REDUCER_NAME].currentTabData;
    const breakOutType = getState()[REDUCER_NAME].filterData[currentTabData]
      .breakOutType;
    const filterLineOne = getState()[REDUCER_NAME].filterData[currentTabData]
      .filterLineOne;
    const filterLineTwo = getState()[REDUCER_NAME].filterData[currentTabData]
      .filterLineTwo;
    const filterLineThree = getState()[REDUCER_NAME].filterData[currentTabData]
      .filterLineThree;
    const sortState = getState()[REDUCER_NAME].sortState;
    Interval.fetch(
      'TAStrategyBreakoutMa',
      dispatch,
      function() {
        dispatch(setLoading(true));
        return taStrategyService.fetchBreakoutMa({
          BreakoutType: breakOutType,
          BreakoutMaBottom: filterLineOne,
          VolumeRateOfChange: filterLineTwo,
          IncreaseInPrice: filterLineThree,
          Page: currentpage,
          PageSize: PAGE_SIZE,
          ...getParamFromSortState(sortState),
        });
      },
      function(response) {
        if (response) {
          const listBreakoutMaData = response.items || [];
          const totalPage = Math.ceil(response.totalCount / PAGE_SIZE);
          dispatch({
            type: FETCH_LIST_BREAKOUT_MA_DATA,
            payload: {
              listBreakoutMaData,
              totalPage,
            },
          });
          dispatch(setLoading(false));
        }
      },
      Const.breakoutMaInterval,
    );
  };
}

function cancelFetchBestInDownTrend() {
  return () => {
    Interval.cancel('TAStrategyDownTrend');
  };
}

function fetchBestInDownTrend() {
  return (dispatch, getState) => {
    const currentpage = DEFAULT_PAGE_LOAD;
    const currentTabData = getState()[REDUCER_NAME].currentTabData;
    const filterLineOne = getState()[REDUCER_NAME].filterData[currentTabData]
      .filterLineOne;
    const filterLineTwo = getState()[REDUCER_NAME].filterData[currentTabData]
      .filterLineTwo;
    const filterLineThree = getState()[REDUCER_NAME].filterData[currentTabData]
      .filterLineThree;
    const sortState = getState()[REDUCER_NAME].sortState;
    Interval.fetch(
      'TAStrategyDownTrend',
      dispatch,
      function() {
        dispatch(setLoading(true));
        return taStrategyService.fetchBestInDownTrend({
          DownTrend: filterLineOne,
          AverageMatchVolume1Month: filterLineTwo,
          ComGroupCode: filterLineThree,
          Page: currentpage,
          PageSize: PAGE_SIZE,
          ...getParamFromSortState(sortState, { icbRank: 'IcbTotalRanked' }),
        });
      },
      function(response) {
        if (response) {
          const listBestDownTrendData = response.items || [];
          const totalPage = Math.ceil(response.totalCount / PAGE_SIZE);
          dispatch({
            type: FETCH_LIST_BEST_DOWN_TREND_DATA,
            payload: {
              listBestDownTrendData,
              totalPage,
            },
          });
          dispatch(setLoading(false));
        }
      },
      Const.bestDownInterval,
    );
  };
}

function cancelFetchMarketAnomaly() {
  return () => {
    Interval.cancel('TAStrategyMarketAnomaly');
  };
}

function fetchMarketAnomaly(
  isLoadMore = false,
  page = 1,
  pageSize = PAGE_SIZE,
) {
  return (dispatch, getState) => {
    const currentTabData = getState()[REDUCER_NAME].currentTabData;
    const filterLineOne = getState()[REDUCER_NAME].filterData[currentTabData]
      .filterLineOne;
    const filterLineTwo = getState()[REDUCER_NAME].filterData[currentTabData]
      .filterLineTwo;
    const filterLineThree = getState()[REDUCER_NAME].filterData[currentTabData]
      .filterLineThree;
    const filterLineFour = getState()[REDUCER_NAME].filterData[currentTabData]
      .filterLineFour;
    const sortState = getState()[REDUCER_NAME].sortState;
    Interval.fetch(
      'TAStrategyMarketAnomaly',
      dispatch,
      function() {
        dispatch(setLoading(true));
        return taStrategyService.fetchMarketAnomaly({
          TimeRange: filterLineTwo,
          AverageMatchVolume1Month: filterLineThree,
          ComGroupCode: filterLineFour,
          Page: page,
          PageSize: pageSize,
          Date: filterLineOne,
          ...getParamFromSortState(sortState),
        });
      },
      function(response) {
        if (response) {
          const listMarketAnomalyData = response.items || [];
          const type = isLoadMore
            ? LOAD_MORE_MARKET_ANOMALY
            : FETCH_LIST_MARKET_ABNOMALY_DATA;
          dispatch({
            type,
            payload: {
              listMarketAnomalyData,
              totalPage: Math.ceil(response.totalCount / PAGE_SIZE),
            },
          });
          dispatch(setLoading(false));
        }
      },
      Const.marketAbnormallyInterval,
    );
  };
}

function subscribeRealtimeTickAccumulation(data) {
  return {
    type: SUBSCRIBE_REALTIME_TICK_ACCUMULATION,
    payload: {
      data,
    },
  };
}

function subscribeRealtimeTickBreakout(data) {
  return {
    type: SUBSCRIBE_REALTIME_TICK_BREAKOUT,
    payload: {
      data,
    },
  };
}

function subscribeRealtimeTickBreakoutMa(data) {
  return {
    type: SUBSCRIBE_REALTIME_TICK_BREAKOUT_MA,
    payload: {
      data,
    },
  };
}

function subscribeRealtimeTickBestDown(data) {
  return {
    type: SUBSCRIBE_REALTIME_TICK_BEST_DOWN,
    payload: {
      data,
    },
  };
}

function subscribeRealtimeTickMarketAnomaly(data) {
  return {
    type: SUBSCRIBE_REALTIME_TICK_MARKET_ABNOMALY,
    payload: {
      data,
    },
  };
}

function setLoading(isLoading) {
  return dispatch => {
    dispatch({
      type: SET_LOADING,
      payload: isLoading,
    });
  };
}

const defaultFilterData = {
  1: {
    filterLineOne: Const.filterTabOne.filterAccumulationPeriod[1],
    filterLineTwo: Const.filterTabOne.filterVolumeRateChange[2],
    filterLineThree: Const.filterTabOne.filterIncreasePrice[3],
  },
  2: {
    breakOutType: Const.filterBreakout.breakOutType.TOP,
    filterLineOne: Const.filterBreakout.filterTimeRange[1],
    filterLineTwo: Const.filterBreakout.filterVolumeRateChange[2],
    filterLineThree: Const.filterBreakout.filterCompGroup[2],
  },
  3: {
    filterLineOne: Const.filterBreakoutMa.breakoutMaBottom[1],
    filterLineTwo: Const.filterBreakoutMa.filterVolumeRateChange[2],
    filterLineThree: Const.filterBreakoutMa.filterIncreasePrice[3],
    breakOutType: Const.filterBreakoutMa.breakOutType.CROSS_DOWN,
  },
  4: {
    filterLineOne: Const.filterBestDownTrend.downTrend[1],
    filterLineTwo: Const.filterBestDownTrend.avgVolume[2],
    filterLineThree: Const.filterBestDownTrend.filterCompGroup[2],
  },
  5: {
    filterLineOne: Const.filterMarketAbnormally.filterWeekday[1],
    filterLineTwo: Const.filterMarketAbnormally.filterTimeRange[3],
    filterLineThree: Const.filterMarketAbnormally.avgVolume[2],
    filterLineFour: Const.filterMarketAbnormally.filterCompGroup[2],
    checkboxMarketNormally: Const.filterMarketAbnormally.optionTime.Daily,
  },
};

const mapSortState = {
  1: { totalMatchVolume: 'desc' },
  2: { totalMatchVolume: 'desc' },
  3: { totalMatchVolume: 'desc' },
  4: { returnDownTrend: 'desc' },
  5: { averageReturn: 'desc' },
};

const initialState = {
  filterData: defaultFilterData,
  totalPage: 1,
  page: 1,

  listDataAccumulationTicker: [],
  listObjectDataAccumulationByTicker: {},

  listDataBreakoutTicker: [],
  listObjectDataBreakoutByTicker: {},

  listDataBreakoutMaTicker: [],
  listObjectDataBreakoutMaByTicker: {},

  listDataBestDownTrendTicker: [],
  listObjectDataBestDownTrendByTicker: {},

  listDataMarketAbnormalyTicker: [],
  listObjectDataMarketAbnormalyByTicker: {},

  isLoading: false,
  sortState: mapSortState[1],
};

function reducer(state = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      const mapTab = {
        Accummulation: 1,
        Breakout: 2,
        BreakoutMa: 3,
        BestInDownTrend: 4,
        MarketAnomaly: 5,
      };
      const currentTab =
        mapTab[getQueryParams('option')] ||
        currentState.get(
          ConstCommon.listComponent.Strategy,
          'TaStrategy.currentTabData',
        ) ||
        1;
      return {
        ...state,
        ...initialState,
        currentTabData: currentTab,
        sortState: mapSortState[currentTab],
      };

    case UNMOUNT_COMPONENT:
      return {};

    case CHANGE_TAB_DATA: {
      return {
        ...state,
        currentTabData: action.payload.tab,
        sortState: mapSortState[action.payload.tab] || {},
      };
    }

    case GET_FILTER_LINE_ONE:
      return {
        ...state,
        filterData: {
          ...state.filterData,
          [state.currentTabData]: {
            ...state.filterData[state.currentTabData],
            filterLineOne: action.payload.value,
          },
        },
      };

    case GET_FILTER_LINE_TWO:
      return {
        ...state,
        filterData: {
          ...state.filterData,
          [state.currentTabData]: {
            ...state.filterData[state.currentTabData],
            filterLineTwo: action.payload.value,
          },
        },
      };

    case GET_FILTER_LINE_THREE:
      return {
        ...state,
        filterData: {
          ...state.filterData,
          [state.currentTabData]: {
            ...state.filterData[state.currentTabData],
            filterLineThree: action.payload.value,
          },
        },
      };

    case GET_FILTER_LINE_FOUR:
      return {
        ...state,
        filterData: {
          ...state.filterData,
          [state.currentTabData]: {
            ...state.filterData[state.currentTabData],
            filterLineFour: action.payload.value,
          },
        },
      };

    case CHANGE_BREAKOUT_TYPE:
      const breakOutType = action.payload.breakOutType;
      return {
        ...state,
        filterData: {
          ...state.filterData,
          [state.currentTabData]: {
            ...state.filterData[state.currentTabData],
            breakOutType: breakOutType,
          },
        },
      };

    case CHANGE_BREAKOUT_MA_TYPE:
      const breakOutMAType = action.payload.breakOutMAType;
      return {
        ...state,
        filterData: {
          ...state.filterData,
          [state.currentTabData]: {
            ...state.filterData[state.currentTabData],
            breakOutType: breakOutMAType,
          },
        },
      };

    case CHANGE_MARKET_NORMALLY_CHECK:
      const checkboxMarketNormally = action.payload.checkboxMarketNormally;
      return {
        ...state,
        filterData: {
          ...state.filterData,
          [state.currentTabData]: {
            ...state.filterData[state.currentTabData],
            checkboxMarketNormally: checkboxMarketNormally,
            filterLineOne: action.payload.lineOne,
          },
        },
      };

    case FETCH_LIST_ACCUMULATION_DATA:
      const listObjectDataAccumulationByTicker = keyBy(
        action.payload.listAccumulationData,
        'organCode',
      );
      const listDataAccumulationTicker = action.payload.listAccumulationData.map(
        item => item.organCode,
      );
      return {
        ...state,
        listDataAccumulationTicker,
        listObjectDataAccumulationByTicker,
        totalPage: action.payload.totalPage,
        page: action.payload.page,
      };

    case FETCH_LIST_BREAKOUT_DATA:
      const listObjectDataBreakoutByTicker = keyBy(
        action.payload.listBreakoutData,
        'organCode',
      );
      const listDataBreakoutTicker = action.payload.listBreakoutData.map(
        item => item.organCode,
      );
      return {
        ...state,
        listDataBreakoutTicker,
        listObjectDataBreakoutByTicker,
        totalPage: action.payload.totalPage,
      };

    case FETCH_LIST_BREAKOUT_MA_DATA:
      const listObjectDataBreakoutMaByTicker = keyBy(
        action.payload.listBreakoutMaData,
        'organCode',
      );
      const listDataBreakoutMaTicker = action.payload.listBreakoutMaData.map(
        item => item.organCode,
      );
      return {
        ...state,
        listDataBreakoutMaTicker,
        listObjectDataBreakoutMaByTicker,
        totalPage: action.payload.totalPage,
      };

    case FETCH_LIST_BEST_DOWN_TREND_DATA:
      const listObjectDataBestDownTrendByTicker = keyBy(
        action.payload.listBestDownTrendData,
        'organCode',
      );
      const listDataBestDownTrendTicker = action.payload.listBestDownTrendData.map(
        item => item.organCode,
      );
      return {
        ...state,
        listDataBestDownTrendTicker,
        listObjectDataBestDownTrendByTicker,
        totalPage: action.payload.totalPage,
      };

    case FETCH_LIST_MARKET_ABNOMALY_DATA:
      const listObjectDataMarketAbnormalyByTicker = keyBy(
        action.payload.listMarketAnomalyData,
        'organCode',
      );
      const listDataMarketAbnormalyTicker = action.payload.listMarketAnomalyData.map(
        item => item.organCode,
      );
      return {
        ...state,
        listDataMarketAbnormalyTicker,
        listObjectDataMarketAbnormalyByTicker,
        marketAnomalyTotalPage: action.payload.totalPage,
      };

    case LOAD_MORE_MARKET_ANOMALY: {
      const listObjectDataMarketAbnormalyByTicker = keyBy(
        action.payload.listMarketAnomalyData,
        'organCode',
      );
      const listDataMarketAbnormalyTicker = action.payload.listMarketAnomalyData.map(
        item => item.organCode,
      );
      return {
        ...state,
        listDataMarketAbnormalyTicker: state.listDataMarketAbnormalyTicker.concat(
          listDataMarketAbnormalyTicker,
        ),
        listObjectDataMarketAbnormalyByTicker: {
          ...state.listObjectDataMarketAbnormalyByTicker,
          ...listObjectDataMarketAbnormalyByTicker,
        },
      };
    }

    case LOAD_MORE_DATA:
      const { listDataMore, page } = action.payload;
      const listTickerMore = listDataMore.map(item => item.organCode);
      const listDataByTicker = keyBy(listDataMore, 'organCode');
      return {
        ...state,
        listDataAccumulationTicker: [
          ...state.listDataAccumulationTicker,
          ...listTickerMore,
        ],
        listObjectDataAccumulationByTicker: {
          ...state.listObjectDataAccumulationByTicker,
          ...listDataByTicker,
        },
        page,
      };

    case LOAD_MORE_BREAKOUT_DATA:
      const listTickerBreakoutMore = action.payload.listDataMore.map(
        item => item.organCode,
      );
      const listDataBreakoutByTicker = keyBy(
        action.payload.listDataMore,
        'organCode',
      );
      return {
        ...state,
        listDataBreakoutTicker: [
          ...state.listDataBreakoutTicker,
          ...listTickerBreakoutMore,
        ],
        listObjectDataBreakoutByTicker: {
          ...state.listObjectDataBreakoutByTicker,
          ...listDataBreakoutByTicker,
        },
        page: action.payload.page,
      };

    case LOAD_MORE_BREAKOUT_MA_DATA:
      const listTickerBreakoutMaMore = action.payload.listDataMore.map(
        item => item.organCode,
      );
      const listDataBreakoutMaByTicker = keyBy(
        action.payload.listDataMore,
        'organCode',
      );
      return {
        ...state,
        listDataBestDownTrendTicker: [
          ...state.listDataBestDownTrendTicker,
          ...listTickerBreakoutMaMore,
        ],
        listObjectDataBreakoutMaByTicker: {
          ...state.listObjectDataBreakoutMaByTicker,
          ...listDataBreakoutMaByTicker,
        },
        page: action.payload.page,
      };

    case LOAD_MORE_BEST_DOWN_DATA:
      const listTickerBestDownMore = action.payload.listDataMore.map(
        item => item.organCode,
      );
      const listDataBestDownByTicker = keyBy(
        action.payload.listDataMore,
        'organCode',
      );
      return {
        ...state,
        listDataBestDownTrendTicker: [
          ...state.listDataBestDownTrendTicker,
          ...listTickerBestDownMore,
        ],
        listObjectDataBestDownTrendByTicker: {
          ...state.listObjectDataBestDownTrendByTicker,
          ...listDataBestDownByTicker,
        },
        page: action.payload.page,
      };

    case SUBSCRIBE_REALTIME_TICK_ACCUMULATION:
      return executeRealtime(
        state,
        'listObjectDataAccumulationByTicker',
        action.payload.data,
      );

    case SUBSCRIBE_REALTIME_TICK_BREAKOUT:
      return executeRealtime(
        state,
        'listObjectDataBreakoutByTicker',
        action.payload.data,
      );

    case SUBSCRIBE_REALTIME_TICK_BREAKOUT_MA:
      return executeRealtime(
        state,
        'listObjectDataBreakoutMaByTicker',
        action.payload.data,
      );

    case SUBSCRIBE_REALTIME_TICK_BEST_DOWN:
      return executeRealtime(
        state,
        'listObjectDataBestDownTrendByTicker',
        action.payload.data,
      );

    case SUBSCRIBE_REALTIME_TICK_MARKET_ABNOMALY:
      return executeRealtime(
        state,
        'listObjectDataMarketAbnormalyByTicker',
        action.payload.data,
      );

    case SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case CHANGE_SORT_STATE:
      return {
        ...state,
        sortState: action.payload,
      };

    default:
      return state;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);

function executeRealtime(globalState, key, data) {
  const listDataByTickerNew = { ...globalState[key] };

  data.forEach(item => {
    if (listDataByTickerNew[item.organCode]) {
      const tickerItem = {
        ...listDataByTickerNew[item.organCode],
      };

      if (tickerItem) {
        tickerItem.totalMatchedVolume = item.totalMatchVolume;
        tickerItem.totalMatchVolume = item.totalMatchVolume;
        tickerItem.matchPrice = item.matchPrice;
        tickerItem.percentPriceChange = item.percentPriceChange;
        tickerItem.tradingDate = item.tradingDate;
      }
      listDataByTickerNew[item.organCode] = tickerItem;
    }
  });

  return { ...globalState, [key]: listDataByTickerNew };
}
